module.exports = __webpack_public_path__ + "img/nav-icon-magnifier_2x.56bd4742.svg";